import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import JobApplicationsOverview from "@widgets/jobApplications/overview/JobApplicationsOverview";

const JobApplications = () => {
    const route: Route = useMemo(() => router.jobApplications, []);

    return (
        <AdminLayout currentPage={route}>
            <JobApplicationsOverview/>
        </AdminLayout>
    );
};

export default JobApplications;